import React, { useState, useEffect } from 'react';
import '../styles/Hero.css';

function Hero({ language }) {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  const wordsEN = ['Integrate.', 'Innovate.', 'Automate.'];
  const wordsFR = ['Intégrez.', 'Innovez.', 'Automatisez.'];

  const words = language === 'fr' ? wordsFR : wordsEN;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [words.length]);

  const scrollDown = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="animated-word">{words[currentWordIndex]}</span>
        </h1>

        <p className="subtitle">
          <span lang="en">
            Enterprise integration partner enabling seamless system connectivity, intelligent automation, and AI-driven transformation.
          </span>
          <span lang="fr">
            Partenaire d’intégration d’entreprise permettant une connectivité fluide des systèmes, une automatisation intelligente et une transformation portée par l’IA.
          </span>
        </p>

        <a href="#services" className="btn primary" onClick={(e) => {
          e.preventDefault();
          scrollDown();
        }}>
          <span lang="en">Our services</span>
          <span lang="fr">Nos services</span>
        </a>
      </div>

      <div className="scroll-down" onClick={scrollDown}>
        <i className="fas fa-chevron-down"></i>
      </div>
    </section>
  );
}

export default Hero;
